import { Compass, Library } from "lucide-react";
import { useTranslation } from "react-i18next";
import { EmptyState } from "@/components/EmptyState";
import { Page } from "@/components/Page";
import { Button } from "@/components/ui/button";
import { HOME_PATH, Link, PROJECTS_PATH } from "../router.tsx";

/**
 * Areas whose backend does not exist yet: they say what will be here and that it is not
 * available yet. No sample, fake or invented records.
 */

export function KnowledgePage() {
  const { t } = useTranslation();
  return (
    <Page width="narrow">
      <EmptyState
        icon={Library}
        title={t("placeholder.knowledge.title")}
        status={t("placeholder.notYet")}
        headingLevel={1}
        action={
          <Button asChild variant="outline" size="sm">
            <Link href={PROJECTS_PATH}>{t("nav.projects")}</Link>
          </Button>
        }
      >
        {t("placeholder.knowledge.body")}
      </EmptyState>
    </Page>
  );
}

export function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <Page width="narrow">
      <EmptyState
        icon={Compass}
        title={t("placeholder.notFound.title")}
        headingLevel={1}
        action={
          <Button asChild size="sm">
            <Link href={HOME_PATH}>{t("placeholder.notFound.home")}</Link>
          </Button>
        }
      >
        {t("placeholder.notFound.body")}
      </EmptyState>
    </Page>
  );
}
